import { Container } from "react-bootstrap";
import anychart from 'anychart';
import { introVSextro } from '../../../calculators/socionics/functions/typeRelations-IvsE'
import { whichRelationIsThis } from '../../../calculators/socionics/functions/whichRelation'
import { useEffect } from "react";
function Bar3d2() {
    let scores = introVSextro()
    let r = []
    for (let i = 0; i < scores.length; i++) {
        r.push(whichRelationIsThis(scores[i]))
    }

    useEffect(() => {
        anychart.onDocumentReady(function () {
            // create data set on our data
            var chartData = {
                header: [
                    '#',
                    'ISFP',
                    'INTJ',
                    'ISTJ',
                    'INFP',
                    'ISFJ',
                    'INTP',
                    'INFJ',
                    'ISTP',
                ],
                rows: [
                    ['ENTP', scores[0], scores[1], scores[2], scores[3], scores[4], scores[5], scores[6], scores[7]],
                    ['ESFJ', scores[8], scores[9], scores[10], scores[11], scores[12], scores[13], scores[14], scores[15]],
                    ['ENFJ', scores[16], scores[17], scores[18], scores[19], scores[20], scores[21], scores[22], scores[23]],
                    ['ESTP', scores[24], scores[25], scores[26], scores[27], scores[28], scores[29], scores[30], scores[31]],
                    ['ENTj', scores[32], scores[33], scores[34], scores[35], scores[36], scores[37], scores[38], scores[39]],
                    ['ESFP', scores[40], scores[41], scores[42], scores[43], scores[44], scores[45], scores[46], scores[47]],
                    ['ESTJ', scores[48], scores[49], scores[50], scores[51], scores[52], scores[53], scores[54], scores[55]],
                    ['ENFP', scores[56], scores[57], scores[58], scores[59], scores[60], scores[61], scores[62], scores[63]],
                ]
            };
            // create column chart
            var chart = anychart.column3d();
            // set chart data
            chart.data(chartData);
            // turn on chart animation
            chart.animation(false);
            chart.yAxis().labels().format('{%Value}{groupsSeparator: }');
            // set titles for Y-axis
            chart.yAxis().title('Compatibility Strength');
            // turn on legend
            chart.legend().enabled(true).fontSize(10).padding([0, 0, 20, 0]);
            // set interactivity settings
            chart.interactivity().hoverMode('single');

            // set tooltip settings
            chart
                .tooltip()
                .positionMode('point')
                .position('center-top')
                .anchor('center-bottom')
                .offsetX(0)
                .offsetY(10)
                .format('{%SeriesName}: {%Value}{groupsSeparator: }');

            // set 3D settings
            chart.zAspect('10%').zPadding(45).zAngle(55).zDistribution(true);

            // set container id for the chart
            chart.container('chartholder2');

            // initiate chart drawing
            chart.draw();
    
        });
    }, [scores])


    return (
        <Container fluid id="chartholder2" className='py-4' style={{ height: '650px' }}>

        </Container>
    )
}

export default Bar3d2;